export interface ScopeItem {
    ScopeType: string | undefined;
    DisplayName?: string;
    MaasScopeType?: string;
    Value?: string | undefined;
    ExtraProperties?: Record<string, string>;
}

export interface ScopeBag {
    ScopeHierarchyId: string;
    Scopes?: ScopeItem[];
}

export enum ScopeHierarchyId {
    SubstrateLogicalScopeHierarchy = "SubstrateLogicalScopeHierarchy",
    SubstrateAccountForestScopeHierarchy = "SubstrateAccountForestScopeHierarchy",
    SubstrateCafeScopeHierarchy = "SubstrateCafeScopeHierarchy",
    SubstratePhysicalScopeHierarchy = "SubstratePhysicalScopeHierarchy",
    IC3ScopeHierarchy = "IC3ScopeHierarchy",
    CosmicScopeHierarchy = "CosmicScopeHierarchy",
    CosmicATMScopeHierarchy = "CosmicATMScopeHierarchy",
    OdspPhysicalScopeHierarchy = "OdspPhysicalScopeHierarchy",
    AzureAdScopeHierarchy = "AzureAdScopeHierarchy",
    DownDetectorScopeHierarchy = "DownDetectorScopeHierarchy",
    Undefined = "Undefined"
}

export interface ScopeHierarchyNode {
    /**
     * The display name of the scope.
     */
    DisplayName: string;
    /**
     * The type of the scope. This is used to identify the scope in the hierarchy.
     */
    ScopeType: string;
    /**
     * This scope type is used to transform the scope type to Maas understandable type.
     * e.g. SubstrateLogicalScopeHierarchy defines "Region" scope type, but Maas expects "Region" to be "ExoRegion".
     */
    MaasScopeType?: string;
    /**
     * The child scopes of this scope.
     * e.g. for a Region, the child scopes could be Forest.
     */
    ChildScopes?: ScopeHierarchyNode[];
    /**
     * The default value of the scope.
     * e.g. for an Environment, the default value could be "PROD" or "Bleu" depending on the cloud environment.
     */
    DefaultValue?: Map<string, string> | string;
}

export interface ScopeHierarchy {
    HierarchyId: string;
    DisplayName: string;
    Root: ScopeHierarchyNode;
}

export interface ScopeContext {
    // context for substrate topology service
    Workload?: string;
    // context for maas scope mapping
    SignalId?: string;
}

export interface GetScopeValuesRequest {
    scopeHierarchyId: string;
    currentScopeTarget: ScopeHierarchyNode;
    selectedScopesSoFar?: ScopeItem[];
    context?: ScopeContext;
}

export interface GetScopeSearchRequest {
    scopeHierarchyId: string;
    selectedScopesSoFar?: ScopeItem[];
    searchText: string;
    context?: ScopeContext;
}

export interface TopologyService {
    getScopeValueOptions: (request: GetScopeValuesRequest) => ScopeItem[] | Promise<ScopeItem[]>;
    getScopeSearch: (request: GetScopeSearchRequest) => ScopeItem[] | Promise<ScopeItem[]>;
}
